export { default } from "./StudentAssignmentTitle";
